import { useMemo } from 'react'

interface ExportSummaryProps {
  selectedSensorCount: number
  estimatedReadings: number
  isLoading?: boolean
  deviceCount?: number
}

export function ExportSummary({
  selectedSensorCount,
  estimatedReadings,
  isLoading = false,
  deviceCount
}: ExportSummaryProps) {
  const formattedReadings = useMemo(() => {
    if (estimatedReadings >= 1000) {
      return `~${(estimatedReadings / 1000).toFixed(1)}k`
    }
    return `~${estimatedReadings.toLocaleString()}`
  }, [estimatedReadings])

  // Build the selection summary text
  const selectionText = useMemo(() => {
    if (deviceCount && deviceCount > 1) {
      return `${deviceCount} devices, ${selectedSensorCount} sensor${selectedSensorCount !== 1 ? 's' : ''}`
    }
    return `${selectedSensorCount} sensor${selectedSensorCount !== 1 ? 's' : ''} selected`
  }, [deviceCount, selectedSensorCount])

  return (
    <div className="flex items-center justify-between text-sm text-gray-500 py-2">
      <span>{selectionText}</span>
      <span>
        {isLoading ? (
          <span className="text-gray-400">Calculating...</span>
        ) : (
          <>Estimated: <span className="font-medium">{formattedReadings}</span> readings</>
        )}
      </span>
    </div>
  )
}
